import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGossipScroll from './components/HotGossipScroll';
import CategoryNav from './components/CategoryNav';
import WaterfallSection from './components/WaterfallSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipScroll />
        <CategoryNav />
        <WaterfallSection />
        <CTASection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}